export default __webpack_public_path__ + "static/media/Advanced Potion Making - Final_29.0005c305.jpg";